import styled from 'styled-components';

import { FaRegCalendar } from 'react-icons/fa';

import theme from '../../theme';

export const StyledCalendarIcon = styled(FaRegCalendar)`
  color: ${theme.colors.gray};
`;
